/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';

import { request } from '@mairistem/tools';

import { BASE_URL_ETATCIVIL } from '@/constants';
import type { CategorieAntsMention, TypeActe } from '@/types';

/**
 * Récupère les catégories de mentions ANTS avec leurs mentions, filtrées par type d'acte.
 */
const useMentionAnts = () => {
  const [categories, setCategories] = useState<Array<CategorieAntsMention>>([]);
  const [loading, setLoading] = useState(false);

  const get = useCallback((typeActe: TypeActe) => {
    setLoading(true);
    setCategories([]);

    request
      .get<unknown, { data: Array<CategorieAntsMention> }>(
        `${BASE_URL_ETATCIVIL}/mention-ants?typeActe=${typeActe}`,
      )
      .then(({ data }) => {
        setCategories(data);
      })
      .catch(() => {
        toast.error('Une erreur est survenue lors du chargement des mentions');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const reset = useCallback(() => {
    setCategories([]);
    setLoading(false);
  }, []);

  return {
    categories,
    loading,
    get,
    reset,
  };
};

export default useMentionAnts;
